import $ from 'jquery';
import 'jquery-validation';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.css';

function submitResetPassword() {
  $.ajax({type: 'POST', url: '/login/wst/reset', data: $('#resetForm').serialize()});
  $('#resetPassword').modal('hide');
}
$('#resetButton').on('click', submitResetPassword);

$('#forgotPassword').on('click', function () {
  $('#resetPassword').modal('show');
});

$(document).ready(function() {
  var rules = {
    username: { required: true, email: true }
  };

  var verify_token = window.ss_vars.verify_token;
  if (verify_token) {
    rules.password = {
      required: true,
      minlength: 8
    };
    rules.verify_password = {
      equalTo: '#password'
    };
  }
  else {
    rules.password = {required: true};
  }

  $("#loginForm").validate({
    rules: rules,
    highlight: function (el) {
      $(el).closest('.input-group').removeClass('has-success').addClass('has-error');
    },
    unhighlight: function (el) {
      $(el).closest('.input-group').removeClass('has-error').addClass('has-success');
    }
  });
});
